import { RootState } from 'editor/src/store/index';

const isLockedImageElementDeletionAllowed = (state: RootState) => state.hostSettings.allowLockedImageElementDeletion;

export default isLockedImageElementDeletionAllowed;
